import React from 'react';
import { Collapse, List, ListItem, ListItemText } from '@mui/material';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { DeactivateAccount } from './DeactivateAccount';
import { DeleteAccount } from './DeleteAccount';

interface AccountContentProps {
  isOpen: boolean;
}

export const DesktopManageAccountContent: React.FC<AccountContentProps> = ({ isOpen }) => {
  const { translation } = useTranslationContext();

  return (
    <Collapse
      in={isOpen}
      timeout="auto"
      unmountOnExit
      id="account__manage-account-section"
      className="desktop-manage-account"
    >
      <List
        sx={{ paddingX: 4 }}
        className="desktop-manage-account__list"
        id="desktop-manage-account-options-list"
      >
        <ListItem id="desktop-manage-account__deactivate-section">
          <ListItemText
            primary={<DeactivateAccount />}
            secondary={translation('deactivate_account_body')}
            secondaryTypographyProps={{
              marginTop: 1,
            }}
          />
        </ListItem>
        <ListItem id="desktop-manage-account__delete-section">
          <ListItemText
            primary={<DeleteAccount />}
            secondary={translation('delete_account_subheader')}
            secondaryTypographyProps={{
              marginTop: 1,
            }}
          />
        </ListItem>
      </List>
    </Collapse>
  );
};
